import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

const PAGE_TITLES = {
  '/': 'Inicio',
  '/clientes': 'Clientes',
  '/horas': 'Registrar Horas',
  '/items': 'Items',
  '/reporte-horas': 'Reporte de Horas'
};

const TopBar = ({ mode, onToggle }) => {
  const { pathname } = useLocation();
  const title = PAGE_TITLES[pathname] || '';
  const isDark = mode === 'dark';

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        px: { xs: 1.5, sm: 2, md: 2.5 },
        py: 0.75,
        backgroundColor: 'background.default',
        borderBottom: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
        <Typography
          sx={{
            fontFamily: '"Source Sans 3", sans-serif',
            fontWeight: 600,
            fontSize: '0.95rem',
            color: 'text.primary',
            letterSpacing: '0.01em',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
          {title}
        </Typography>
      </Box>
      <Tooltip title={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}>
        <IconButton onClick={onToggle} size="small">
          {isDark ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default TopBar;
